/*
 *
 * SignUpPage
 *
 */

import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';
import {
  Wrapper,
  Container,
  Heading,
  PriceBox,
  PriceBoxHead,
  Ul,
  Li,
  Tabholder,
  PriceBoxActive,
  PriceBoxHeadActive,
} from './styledComponents';
import H1 from 'components/H1';
import Button from 'components/Button';
import FormTabs from 'components/FormTabs';
import { createStructuredSelector } from 'reselect';
import {
  selectCurrentTab,
} from 'containers/ChannelsPage/selectors';
import {
  changeTab,
} from 'containers/ChannelsPage/actions';
const formsObj = {
      YEARLY: {
        disabled: false,
        title: 'Pay Yearly',
        renderForm: () => (
          <div>
            <PriceBox>
              <PriceBoxHead>
                Memento Lite
              </PriceBoxHead>
              <H1>$91</H1>
              <span>per month</span>
              <Ul>
                <Li>
                  access to all templates
                </Li>
                <Li>
                  online photo gallery
                </Li>
                <Li>
                 <strong> one </strong>event per month
                </Li>
              </Ul>
              <Link to={{pathname: '/nice-choice/memento_lite_annual/1188/96'}} >
                <Button >Go Lite</Button>
              </Link>
            </PriceBox>
            <PriceBoxActive>
              <PriceBoxHeadActive>
                Memento Unlimited
              </PriceBoxHeadActive>
              <H1>$189</H1>
              <span>per month</span>
              <Ul>
                <Li>
                 access to all templates
                </Li>
                <Li>
                  online photo gallery
                </Li>
                <Li>
                  <strong>unlimited</strong> events
                </Li>
              </Ul>
              <Link to={{pathname: '/nice-choice/memento_unlimited_annual/2388/228' }} >
                <Button>Go Unlimited</Button>
              </Link>
            </PriceBoxActive>
          </div>
        ),
      },
      MONTHLY: {
        disabled: false,
        title: 'Pay Monthly',
        renderForm: () => (
          <div>
            <PriceBox>
              <PriceBoxHead>
                Memento Lite
              </PriceBoxHead>
              <H1>$99</H1>
              <span>per month</span>
              <Ul>
                <Li>
                  access to all templates
                </Li>
                <Li>
                  online photo gallery
                </Li>
                <Li>
                 <strong> one </strong>event per month
                </Li>
              </Ul>
              <Link to={{pathname: '/nice-choice/memento_lite_monthly/99/0'}}>
                <Button>Go Lite</Button>
              </Link>
            </PriceBox>
            <PriceBoxActive>
              <PriceBoxHeadActive>
                Memento Unlimited
              </PriceBoxHeadActive>
              <H1>$199</H1>
              <span>per month</span>
              <Ul>
                <Li>
                 access to all templates
                </Li>
                <Li>
                  online photo gallery
                </Li>
                <Li>
                  <strong>unlimited</strong> events
                </Li>
              </Ul>
               <Link to={{pathname: '/nice-choice/memento_unlimited_monthly/199/0'}} >
                <Button>Go Unlimited</Button>
              </Link>
            </PriceBoxActive>
          </div>
        ),
      }
    }
const tabs = [ formsObj['YEARLY'],formsObj['MONTHLY'] ]
const MementoPlan = ({
  currentTab,
  onTabChange,
}) => (
  <Wrapper>
    <Helmet title='Movebooth | Memento Plan' />
    {
      <Container>
        <Heading>
          <H1>
           Which Memento plan is right for you?
          </H1>
          You’ve seen the value Memento by Movebooth can create for your business with your first free event. Now, let’s make this a regular thing!
        </Heading>
        <Tabholder>
          <FormTabs
            currentTab={currentTab}
            onTabChange={onTabChange}
            tabs={tabs}
            mementoPlan={true}
          />
        </Tabholder>
      </Container>
    }
  </Wrapper>
);
const mapStateToProps = createStructuredSelector({
  currentTab: selectCurrentTab(),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onTabChange: (tab) => dispatch(changeTab(tab)),
  nextTab: (currentTab) => dispatch(changeTab(currentTab)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MementoPlan);



// WEBPACK FOOTER //
// ./src/containers/MementoPlan/index.js